import React from 'react';
import styled from 'styled-components';

import PageIcon from './../PageIcon';

const ItemText = styled.div`
  display: inline-block;
  margin-left: 20px;
  margin-top: 16px;
  font-family: BrandonGrotesque-Regular;
  font-weight: 900;
  font-size: 15px;
  letter-spacing: 1.5px;
  color: ${(props) => (props.active ? 'var(--color-beige);' : 'var(--color-gunmetal);')};
`;

const Item = styled.div`
  height: 50px;
  width: ${(props) => (props.mini ? '125px' : '250px')};
  padding: 0;
  margin-bottom: 3px;
  cursor: pointer;
  background-color: ${(props) =>
    props.active ? 'var(--color-gunmetal-two)' : 'var(--color-white-two)'};
  padding-top: ${(props) => (props.mini ? '9px' : 'initial')};
`;

interface Props {
  onClick: any;
  active: boolean;
  mini?: boolean;
  icon: any;
  text: string;
}

function MenuItem(props: Props) {
  return (
    <Item active={props.active} mini={props.mini} onClick={() => props.onClick()}>
      <PageIcon icon={props.icon} active={props.active} mini={props.mini} />
      {props.mini ? null : <ItemText active={props.active}>{props.text}</ItemText>}
    </Item>
  );
}
export default MenuItem;
